import React from 'react';
import { CbmModal, GoodDeal } from '@groupelacentrale/contact-storybook';
import { IconClose, IconOk } from '@groupelacentrale/contact-storybook/lib/icons';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const BadgeInformationsModal: React.FC<Props> = ({ isOpen, onClose }) => (
  <CbmModal
    title="Positionnement prix des annonces"
    isOpen={isOpen}
    size="medium"
    onClose={onClose}
    className="badge-infos-modal"
  >
    <div>
      La Centrale vous informe sur le positionnement prix des annonces par rapport au prix moyen des annonces
      similaires. Plus le prix est en dessous du prix moyen, meilleure sera l&apos;affaire.
    </div>
    <div className="quality-rate-infos-title">Ces prix moyens :</div>
    <div className="quality-rate-infos-lists">
      <ul>
        <li className="qr-infos-list-title">tiennent compte</li>
        <li>
          <IconOk width={16} color="green" />
          des marque, modèle, génération du véhicule
        </li>
        <li>
          <IconOk width={16} color="green" />
          de la version (avec les équipements standards de la version)
        </li>
        <li>
          <IconOk width={16} color="green" />
          du carburant
        </li>
        <li>
          <IconOk width={16} color="green" />
          de la boîte de vitesse
        </li>
        <li>
          <IconOk width={16} color="green" />
          de la date de mise en circulation
        </li>
        <li>
          <IconOk width={16} color="green" />
          du kilométrage réel
        </li>
        <li>
          <IconOk width={16} color="green" />
          de la zone géographique
        </li>
      </ul>
      <ul>
        <li className="qr-infos-list-title">ne tiennent pas compte</li>
        <li>
          <IconClose width={14} color="red" />
          des marque, modèle, génération du véhicule
        </li>
        <li>
          <IconClose width={14} color="red" />
          des garanties spécifiques
        </li>
        <li>
          <IconClose width={14} color="red" />
          du nombre de propriétaires
        </li>
        <li>
          <IconClose width={14} color="red" />
          de la couleur du véhicule
        </li>
        <li>
          <IconClose width={14} color="red" />
          des réparations récemment effectuées ou à effectuer
        </li>
        <li>
          <IconClose width={14} color="red" />
          d&apos;un état éventuellement dégradé par rapport à une usure normale
        </li>
      </ul>
    </div>
    <div className="quality-rate-infos-legend-title">Qualité du positionnement prix des annonces</div>
    <dl className="quality-rate-infos-legend">
      <dt>
        <GoodDeal rate={5} />
      </dt>
      <dd>Le prix de l&apos;annonce est très en-dessous de la moyenne des prix des véhicules similaires.</dd>
      <dt>
        <GoodDeal rate={4} />
      </dt>
      <dd>Le prix de l&apos;annonce est en-dessous de la moyenne des prix des véhicules similaires.</dd>
      <dt>
        <GoodDeal rate={3} />
      </dt>
      <dd>Le prix de l&apos;annonce est dans la moyenne des prix des véhicules similaires.</dd>
      <dt>
        <GoodDeal rate={2} />
      </dt>
      <dd>
        Le prix de l&apos;annonce est supérieur à la moyenne des prix des véhicules similaires. Cela ne signifie pas
        forcément que le véhicule est trop cher, il peut avoir des options ou des garanties supplémentaires.
        Renseignez-vous auprès du vendeur.
      </dd>
      <dt>
        <GoodDeal rate={1} />
      </dt>
      <dd>
        Le prix de l&apos;annonce est très supérieur à la moyenne des prix des véhicules similaires. Le véhicule est
        sans doute rare ou peut être suréquipé ou très atypique. Renseignez-vous auprès du vendeur.
      </dd>
      <dt>
        <GoodDeal rate={0} />
      </dt>
      <dd>Les données ne sont pas suffisantes pour mesurer le positionnement prix de l&apos;annonce.</dd>
    </dl>
  </CbmModal>
);

export default BadgeInformationsModal;
